import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const DEFAULT_DASHBOARD_FONT = 'inter';

export const DASHBOARD_FONT_OPTIONS = [
  {
    key: 'inter',
    label: 'Inter',
    description: 'Limpa e compacta',
    family: "'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'manrope',
    label: 'Manrope',
    description: 'Moderna e espaçosa',
    family:
      "'Manrope Variable', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'system',
    label: 'Do dispositivo',
    description: 'A fonte nativa do sistema',
    family:
      "-apple-system, BlinkMacSystemFont, system-ui, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
];

export const normalizeDashboardFont = font =>
  DASHBOARD_FONT_OPTIONS.some(option => option.key === font)
    ? font
    : DEFAULT_DASHBOARD_FONT;

export const setDashboardFont = font => {
  const normalizedFont = normalizeDashboardFont(font);
  const option = DASHBOARD_FONT_OPTIONS.find(
    item => item.key === normalizedFont
  );

  document.documentElement.style.setProperty(
    '--dashboard-font-family',
    option.family
  );
  document.documentElement.dataset.dashboardFont = normalizedFont;
  LocalStorage.set(LOCAL_STORAGE_KEYS.DASHBOARD_FONT, normalizedFont);

  return normalizedFont;
};

export const initializeDashboardFont = preferredFont =>
  setDashboardFont(
    preferredFont ||
      LocalStorage.get(LOCAL_STORAGE_KEYS.DASHBOARD_FONT) ||
      DEFAULT_DASHBOARD_FONT
  );
